import { AlertTriangle } from "lucide-react";
import { useCoverage } from "@/hooks/use-categories";

export function CategoryCoverageWarning() {
  const { data: coverage, isLoading } = useCoverage();

  if (isLoading || !coverage) return null;

  const incompleteJobTypes = coverage.jobTypes.filter((jt) => !jt.isComplete);
  const incompleteCategories = coverage.incompleteCategories;

  if (incompleteJobTypes.length === 0 && incompleteCategories.length === 0) return null;

  return (
    <div className="callout callout--warn mb-4">
      <AlertTriangle className="callout__icon" />
      <div>
        <strong className="callout__title">Configuration incomplete</strong>
        {incompleteJobTypes.length > 0 && (
          <p className="text-sm mt-1">
            Job types with no active categories:{" "}
            {incompleteJobTypes.map((jt) => (
              <span key={jt.id} className={`chip-jobtype chip-jobtype--${jt.code} ml-1`}>
                {jt.code}
              </span>
            ))}
          </p>
        )}
        {incompleteCategories.length > 0 && (
          <p className="text-sm mt-1">
            Categories with no active subtasks:{" "}
            <strong>{incompleteCategories.map((c) => c.name).join(", ")}</strong>
          </p>
        )}
        <p className="text-sm mt-2 text-muted-foreground">
          Engineers cannot be assigned until all job types have at least one active category with at
          least one active subtask.
        </p>
      </div>
    </div>
  );
}
